import _draftJs from 'draft-js';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
function getEntityMappingAdjustments(contentState, block, blockKey) {
  const entityKeys = {};
  const modifiedBlockSize = block.getCharacterList().size;
  for (let i = 0; i < modifiedBlockSize; i++) {
    const key = block.getEntityAt(i);
    if (key && !entityKeys[key]) {
      entityKeys[key] = {
        entity: contentState.getEntity(key),
        startIndex: i,
        endIndex: i,
      };
    } else if (key && entityKeys[key]) {
      entityKeys[key].endIndex = i;
    }
  }
  const keyEntityTuples = Object.entries(entityKeys);
  return keyEntityTuples
    .filter((t) => t[1].entity.get('type') == 'mention')
    .map((t) => {
      const entityKey = t[0];
      const selectionState = _draftJs.SelectionState.createEmpty(blockKey).merge({
        anchorKey: blockKey,
        anchorOffset: t[1].startIndex - 1,
        focusOffset: t[1].endIndex,
      });
      return { entityKey, selectionState };
    });
}
var changeCurrentBlockType = function changeCurrentBlockType(editorState, type, text) {
  var blockMetadata = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var currentContent = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var blockMap = currentContent.getBlockMap();
  var block = blockMap.get(key);
  var data = block.getData().merge(blockMetadata);
  var newBlock = block.merge({
    type: type,
    data: data,
    text: text || '',
  });
  var newSelection = selection.merge({
    anchorOffset: 0,
    focusOffset: 0,
  });
  var newContentState = currentContent.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: newSelection,
  });
  /* Hack for correcting mention entity character mapping errors when creating a bulleted list */
  const entityAdjustments = getEntityMappingAdjustments(currentContent, block, key);
  // capture selection state before adjusting entity character mappings
  const selectionStateWithNewBlock = newContentState.getSelectionAfter();
  const correctedContentState = entityAdjustments.reduce(
    (_contentState, { entityKey, selectionState }) =>
      _draftJs.Modifier.applyEntity(_contentState, selectionState, entityKey),
    newContentState,
  );
  let newEditorState = _draftJs.EditorState.push(
    editorState,
    correctedContentState,
    'change-block-type',
  );
  // apply the previously captured selection state
  newEditorState = _draftJs.EditorState.forceSelection(newEditorState, selectionStateWithNewBlock);
  return newEditorState;
};
var _default = changeCurrentBlockType;
export default _default;
